import React from "react";
import CustomTooltip from "./CustomTooltip";
import PortalCard from "../../portalCard/PortalCard";
import CustomAreaChart from "../../areaChart/AreaChart";
import Loading from "../../Loading/Loading";
import styles from "./EngagmentChart.module.css";

const EngagmentChart = ({ graphData, isLoading }) => {
  const dataToDisplay = Array.isArray(graphData) ? graphData : [];

  return (
    <PortalCard style={{ height: 450 }}>
      <h2 className={styles.titleContainer}>Engagement</h2>
      {isLoading && (
        <div className={styles.chartLoadingOverlay}>
          <Loading />
        </div>
      )}
      <CustomAreaChart
        chartData={dataToDisplay}
        dynamicDataKey="members" // This must match the key in your data objects
        xAxisKey="date"
        yAxisTickFormatter={(value) => `${value}`}
        yAxisDomain={["auto", "auto"]}
        CustomTooltip={CustomTooltip}
      />
    </PortalCard>
  );
};

export default React.memo(EngagmentChart);
